export default __webpack_public_path__ + "static/access_reviews-9fa076a08cbfe5dd0f6473f8e3feddeb.svg";